import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div className="container">
      <div className="card stack" style={{ textAlign: 'center' }}>
        <h1>Page not found</h1>
        <p className="muted">The page you’re looking for doesn’t exist.</p>
        <Link to="/">Go home</Link>
      </div>
    </div>
  );
}
